import React from 'react';
import { UIText1 } from '@cian/ui-kit';

import { SidebarTip } from './SidebarTip';
import { FindRealtorImage } from '../Images';

/**
 * Карточка про подбор риелтора в сайдбаре
 */
export const SidebarFindRealtorTip = () => {
  return (
    <SidebarTip title="Подберём риелтора" theme={'var(--theme-gray)'} image={<FindRealtorImage />}>
      <UIText1>
        Надежный специалист возьмет на&ndsp;себя&ndsp;решение юридических вопросов и&ndsp;поможет выгодно продать
        сложные&ndsp;объекты
      </UIText1>
    </SidebarTip>
  );
};
